import { FormBase } from "core/components";

export default class FacilityInventoryCountDetailEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'productId',
                    label: 'FACILITY_INVENTORY_DETAIL.EDIT.PRODUCT_LABEL',
                    placeholder: 'FACILITY_INVENTORY_DETAIL.EDIT.PRODUCT_PLACEHOLDER',
                    rules: 'required|string'
                },
                {
                    name: 'quantity',
                    label: 'FACILITY_INVENTORY_DETAIL.EDIT.QUANTITY_LABEL',
                    placeholder: 'FACILITY_INVENTORY_DETAIL.EDIT.QUANTITY_PLACEHOLDER',
                    rules: ['numeric', 'min:0', 'max:999.99'],
                    type: 'numeric'
                },        
                {
                    name: 'caseQty',
                    label: 'FACILITY_INVENTORY_DETAIL.EDIT.CASE_QUANTITY_LABEL',
                    placeholder: 'FACILITY_INVENTORY_DETAIL.EDIT.CASE_QUANTITY_PLACEHOLDER',
                    rules: ['numeric', 'min:0', 'max:999.99'],
                    type: 'numeric'
                },              
                {
                    name: 'eachQty',
                    label: 'FACILITY_INVENTORY_DETAIL.EDIT.EACH_QUANTITY_LABEL',
                    placeholder: 'FACILITY_INVENTORY_DETAIL.EDIT.EACH_QUANTITY_PLACEHOLDER',
                    rules: ['numeric', 'min:0', 'max:999.99'],
                    type: 'numeric'
                },       
            ],
        };
    }
}